<template>
  <div>
    <form data-vv-scope="step-1-part-1" v-on:submit.prevent autocomplete="off">
      <div class="row mt-1 d-flex align-items-end">
        <div class="col-12">
          <h4>Identificación del remitente</h4>
        </div>
        <div class="col-12 d-flex align-items-center mt-5">
          <h6>Remitente:</h6>
          <b-form-group>
            <b-form-radio-group
              id="sender-types"
              v-model="step.sender"
              name="sender-type"
              :disabled="isBlocked"
            >
              <b-form-radio
                @change="clearSender()"
                class="ml-3 mr-5"
                value="CIU"
                data-cy="check-citizen"
              >
                Ciudadano/a
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="ml-3 mr-5"
                value="SAN"
                data-cy="health-check"
              >
                Sanitaria
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="mr-5"
                value="PJU"
                data-cy="check-legal-entity"
              >
                Persona Jurídica
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="mr-5"
                value="OES"
                data-cy="check-state-agency"
              >
                Organismo del estado
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            :label="step.sender === 'CIU' ? 'Rut Emisor' : 'Rut remitente'"
            v-model="step.senderIut"
            data-vv-as="rut"
            name="senderIut"
          />
        </div>
        <div class="col-6">
          <vs-input
            v-model="step.senderName"
            autocomplete="off"
            class="w-100"
            :label="step.sender === 'CIU' ? 'Nombre *' : 'Nombre remitente *'"
            data-vv-as="nombre"
            v-validate="'required|max:200'"
            name="senderName"
            :danger="errors.has('step-1-part-1.senderName')"
            :danger-text="errors.first('step-1-part-1.senderName')"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div
          class="col-6"
          v-if="step.sender === 'SAN' || step.sender === 'PJU'"
        >
          <vs-input
            autocomplete="off"
            class="w-100"
            :label="iutLabel"
            v-model="step.senderCompanyIut"
            :data-vv-as="iutLabel.toLowerCase()"
            v-validate="{ validateRut: true }"
            name="senderCompanyIut"
            :danger="errors.has('step-1-part-1.senderCompanyIut')"
            :danger-text="errors.first('step-1-part-1.senderCompanyIut')"
          />
        </div>
        <div
          class="col-6"
          v-if="step.sender === 'PJU' ||
        step.sender === 'OES' ||
        step.sender === 'SAN'"
        >
          <vs-input
            v-if="step.sender === 'PJU' || step.sender === 'OES'"
            v-model="step.senderCompanyName"
            autocomplete="off"
            class="w-100"
            :label="nameLabel"
            :data-vv-as="nameLabel.replace('*', '').toLowerCase()"
            v-validate="{
            required: step.sender === 'PJU' || step.sender === 'OES',
            max: '200'
          }"
            name="senderCompanyName"
            :danger="errors.has('step-1-part-1.senderCompanyName')"
            :danger-text="errors.first('step-1-part-1.senderCompanyName')"
          />
          <ListSanitaryCompanies
            v-if="step.sender === 'SAN'"
            autocomplete="off"
            data-vv-as="empresa sanitaria"
            v-model="step.senderCompanyName"
            name="senderCompanyName"
            :isClearable="false"
            label="Empresas Sanitarias *"
            ref="sanitaryCompanies"
            v-validate="{
            required: step.sender === 'SAN',
            max: '200'
          }"
            @input="setSanitary"
            :clearSanitary="clearSanitary"
            :danger="errors.has('step-1-part-1.senderCompanyName')"
            :danger-text="errors.first('step-1-part-1.senderCompanyName')"
          />
        </div>
      </div>
      <div
        class="row mt-3"
      >
        <div class="col-6 d-flex align-items-end">
          <div class="w-100">
            <ListCommunes
              label="Comunas *"
              autocomplete="off"
              data-vv-as="comuna"
              v-model="step.senderComune"
              name="senderComune"
              :isClearable="false"
              :clearCommune="clearCommune"
              v-validate="'required'"
              :danger="errors.has('step-1-part-1.senderComune')"
              :danger-text="errors.first('step-1-part-1.senderComune')"
              :state="errors.has('step-1-part-1.senderComune') ? false : null"
            />
          </div>
        </div>
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Dirección"
            data-vv-as="dirección"
            name="senderAddress"
            v-model="step.senderAddress"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Correo electrónico"
            data-vv-as="correo electrónico"
            name="senderEmail"
            v-model="step.senderEmail"
            :danger="errors.has('step-1-part-1.senderEmail')"
            :danger-text="errors.first('step-1-part-1.senderEmail')"
          />
        </div>
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            label="Teléfono"
            placeholder="Escriba en formato +56912345678"
            v-model="step.senderPhone"
            data-vv-as="teléfono"
            v-validate="{ regex: phoneRegex }"
            name="senderPhone"
            :danger="errors.has('step-1-part-1.senderPhone')"
            :danger-text="errors.first('step-1-part-1.senderPhone')"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <SelectValidate
            label="Oficina SISS destino *"
            v-model="step.subjectOffice"
            :options="sissSubjectOffices"
            data-vv-as="oficina destino"
            v-validate="'required'"
            name="subjectOffice"
            ref="subjectOffice"
            :danger="errors.has('step-1-part-1.subjectOffice')"
            :danger-text="errors.first('step-1-part-1.subjectOffice')"
            :state="errors.has('step-1-part-1.subjectOffice') ? false : null"
          />
        </div>
      </div>
      <div class="row mb-3 mt-3">
        <div class="col-12">
          <h4>Descripción del Documento</h4>
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Código Documento"
            name="documentCode"
            data-cy= "document-code"
            v-model="previewCode"
            disabled
          />
        </div>
        <div class="col-md-6 mt-3">
          <label>Fecha de ingreso *</label>
          <date-picker
            data-cy="date-of-admission"
            class="w-100"
            name="issueDate"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            data-vv-as="fecha de ingreso"
            :danger="errors.has('step-1-part-1.issueDate')"
            :danger-text="errors.first('step-1-part-1.issueDate')"
            v-validate="'required'"
            v-model="step.issueDate"
          />
          <div v-if="errors.has('step-1-part-1.issueDate')">
            <small class="text-danger">
              {{ errors.first('step-1-part-1.issueDate') }}
            </small>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <list-document-types-externals
            class="w-100"
            autocomplete
            label="Tipo Documento *"
            name="documentType"
            v-model="step.documentType"
            @change="updateNumeration"
            :danger="errors.has('step-1-part-1.documentType')"
            :danger-text="errors.first('step-1-part-1.documentType')"
            v-validate="'required'"
            ref="documentTypes"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Nº Documento *"
            name="documentNumber"
            data-cy="document-number"
            data-vv-as="nº documento"
            v-model="step.documentNumber"
            :danger="errors.has('step-1-part-1.documentNumber')"
            :danger-text="errors.first('step-1-part-1.documentNumber')"
            v-validate="'required'"
          />
        </div>
        <div class="col-md-6 mt-3">
          <ListProcess
            class="w-100"
            autocomplete
            label="Proceso *"
            placeholder="Seleccione..."
            name="process"
            v-model="step.process"
            @get-option-id="getOptionId"
            @change="updateNumeration"
            data-vv-as="proceso"
            :danger="errors.has('step-1-part-1.process')"
            :danger-text="errors.first('step-1-part-1.process')"
            v-validate="'required'"
            ref="process"
          />
        </div>
        <div class="col-md-6 mt-3">
          <ListSubProcess
            class="w-100"
            autocomplete
            label="Subproceso *"
            name="subProcess"
            v-model="step.subProcess"
            @change="updateNumeration"
            :parent-value="processId"
            data-vv-as="subproceso"
            v-validate="'required'"
            :danger="errors.has('step-1-part-1.subProcess')"
            :danger-text="errors.first('step-1-part-1.subProcess')"
            ref="subProcess"
          />
        </div>
        <div class="col-md-12 mt-3">
          <label>Materia *</label>
          <vs-textarea
            type="text"
            id="matter"
            label="Materia (Mínimo 2 palabras, máximo 5000 caracteres)"
            name="matter"
            width="100%"
            v-validate="'required|min:3'"
            height="100px"
            maxlength="5000"
            class="mb-0"
            v-model="step.matter"
          />
          <div v-if="errors.first('step-1-part-1.matter')"
               class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
               style="height: 32px;">
          <span class="span-text-validation">
            {{errors.first('step-1-part-1.matter')}}
          </span>
          </div>
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Código RIF"
            name="rifCode"
            v-model="step.rifCode"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Número expediente sancionatorio"
            name="documentNumber"
            data-cy="sanction-file-number"
            v-model="step.fileNumberEntry"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="N° de oficio"
            name="rifCode"
            data-cy="office-number"
            v-model="step.numberRidex"
          />
        </div>
        <div class="col-md-6 mt-3">
          <vs-input
            class="w-100"
            label="Número SAC"
            name="documentNumber"
            data-cy="sac-number"
            v-model="step.numberSac"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Responsable *</h4>
          <small>
            Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual
          </small>
        </div>
      </div>
    </form>
    <form data-vv-scope="step-1-part-2">
      <SelectSubject
        @add-subject="addSubject"
        scope="step-1-part-2"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            v-if="step.subjects"
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
          />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-1-part-4">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Adjuntar Documento</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <h5>Documento principal *</h5>
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <UploadFileAdvanced
            permission="*"
            text="Seleccionar archivo"
            accept=".pdf,.rar,.zip,"
            :max-size-in-mb="30"
            v-model="step.mainFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <h5>Documentos adicionales</h5>
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <UploadFileAdvanced
            permission="*"
            text="Seleccionar archivo"
            accept=".pdf,.rar,.zip,"
            :max-size-in-mb="30"
            v-model="additionalFile"
            upload-to="ed"
            button-class="btn-block"
            container-class="w-100"
            @input="addAdditionalFile()"
          />
        </div>
      </div>
      <div class="row mb-3" v-if="step.mainFile.name || step.additionalFiles.length">
        <div class="col-12">
          <b-table-simple hover small>
            <b-thead>
              <b-tr>
                <b-th scope="col">Nombre archivo</b-th>
                <b-th scope="col">Nombre documento</b-th>
                <b-th scope="col">Formato</b-th>
                <b-th scope="col">-</b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-if="step.mainFile.name">
              <b-tr>
                <b-td>
                  <div v-tooltip="'Principal'" class="d-flex align-items-center">
                    <vs-icon icon="file_present" size="medium" class="mr-1"/>
                    {{step.mainFile.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="step.mainFile.currentDescription"/>
                </b-td>
                <b-td>
                  <b-form-select
                    v-model="step.mainFile.format"
                    :options="trueCopyOptions"
                    @change="setInputFormat()"
                  >
                  </b-form-select>
                </b-td>
              </b-tr>
            </b-tbody>
            <b-tbody v-if="step.additionalFiles.length">
              <b-tr v-for="file in step.additionalFiles" :key="file.id">
                <b-td>
                  <div v-tooltip="'Principal'" class="d-flex align-items-center">
                    <vs-icon icon="file_present" size="medium" class="mr-1"/>
                    {{file.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="file.currentDescription"/>
                </b-td>
                <b-td>
                  <b-form-select
                    v-model="file.format" :options="trueCopyOptions"
                    @change="setInputFormat()"
                  >
                  </b-form-select>
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    @click="removeAdditionalFile(file.id)"
                  >
                    remover
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mt-3">
          <label>Documento Reservado</label>
        </div>
        <div class="col-md-1 mt-3">
          <vs-radio
            vs-name="isPrivate"
            :vs-value="2"
            v-model="step.isPrivate"
            data-cy="yes-reserved-document"
          >
            Si
          </vs-radio>
        </div>
        <div class="col-md-1 mt-3">
          <vs-radio
            vs-name="isPrivate"
            :vs-value="0"
            v-model="step.isPrivate"
            data-cy="no-reserved-document"
          >
            No
          </vs-radio>
        </div>
        <div class="col-6 mt-3">
          <label>Formato de ingreso *</label>
          <b-form-select
            class="w-100"
            v-model="step.entryFormatFile"
            :options="inputFormatOptions"
            v-validate="'required'"
            name="subjectTypeDigitalDoc"
            :danger="errors.has('step-1-part-4.subjectTypeDigitalDoc')"
            :danger-text="errors.first('step-1-part-4.subjectTypeDigitalDoc')"
          />
          <b-form-invalid-feedback
            class="d-none w-100"
            :state="!errors.has('step-1-part-4.subjectTypeDigitalDoc')">
            Formato de ingreso es obligatorio
          </b-form-invalid-feedback>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-input
            class="w-100"
            label="Enlace a carpeta compartida"
            name="linktoFolder"
            v-model="step.linkToFolder"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3">
          <b-form-checkbox
            class="d-inline-block"
            v-model="step.declaration"
            data-cy="check-confirmation"
          >
            Declaro que los datos consignados son expresión fiel de la realidad
          </b-form-checkbox>
        </div>
      </div>
      <div
        v-if="error.message !== ''"
        class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
        style="height: 32px;">
        <span class="span-text-validation">
          {{error.message}}
        </span>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Vue from 'vue';
import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import SelectValidate from '@/febos/chile/_vue/componentes/SelectValidate';
import ListCommunes from '@/febos/chile/lists/components/ListCommunes';
import UploadFileAdvanced
from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/UploadFileAdvanced';
import ListSanitaryCompanies
from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/ListSanitaryCompanies';
import ListDocumentTypesExternals from '@/febos/chile/lists/components/ListDocumentTypesExternals';
import ListProcess from '@/febos/chile/lists/components/ListProcess';
import ListSubProcess from '@/febos/chile/lists/components/ListSubProcess';
import SelectSubject from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/SelectSubject';
import TableSubjects from '@/febos/chile/dnt/components/wizard/companies/61221000-4/components/TableSubjects';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import { listOptions } from '@/febos/servicios/api/opciones.api';

export default {
  mixins: [WizardStep, RutMixin],
  components: {
    ListCommunes,
    UploadFileAdvanced,
    ListSanitaryCompanies,
    ListDocumentTypesExternals,
    ListProcess,
    ListSubProcess,
    SelectSubject,
    TableSubjects,
    SelectValidate,
    DatePicker
  },
  data() {
    const { id } = this.$route.params;
    return {
      isBlocked: !!id,
      sissSubjectOffices: [],
      agencyOptions: [],
      phoneRegex: /^[+][0-9]{10,11}$/,
      error: {
        message: ''
      },
      subjectForm: {
        subjectType: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      inputFormatOptions: [
        { text: 'Papel', value: 'papel' },
        { text: 'Papel y Digital', value: 'papel_digital' },
        { text: 'Digital', value: 'digital' },
      ],
      trueCopyOptions: [
        { text: 'Papel', value: 'Papel' },
        { text: 'Digital', value: 'Digital' }
      ],
      processId: '',
      step: {
        numberExp: '',
        origin: 'internalEntry',
        sender: id ? '' : 'CIU',
        senderAgency: '',
        senderIut: '',
        senderName: '',
        senderCompanyIut: '',
        senderCompanyName: '',
        senderComune: '',
        senderAddress: '',
        senderEmail: '',
        senderPhone: '',
        subjectOffice: '',
        documentType: '',
        documentCode: '',
        issueDate: '',
        rifCode: '',
        fileNumber: '',
        numberRidex: '',
        numberSac: '',
        fileNumberEntry: '',
        responsible: '',
        documentNumber: '',
        process: '',
        subProcess: '',
        matter: '',
        description: '',
        mainFile: {},
        additionalFiles: [],
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        linkToFolder: '',
        isPrivate: 0,
        entryFormatFile: '',
        declaration: false,
        ...this.draft
      },
      additionalFile: {},
    };
  },
  watch: {
    subjects(newValue) {
      this.subjectsSelected = newValue;
      this.subjects = newValue;
    },
    copies(newValue) {
      this.copiesSelected = newValue;
      this.copies = newValue;
    },
    // eslint-disable-next-line func-names
    'step.mainFile.name': function () {
      this.$validator.reset();
    },
    // eslint-disable-next-line func-names
    'step.mainFile': function () {
      if (this.step.mainFile.format) {
        this.step.entryFormatFile = this.step.mainFile.format.toLowerCase();
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'documentsState',
      'sanitaryCompaniesState',
      'documentProcessState'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    previewCode() {
      const process = this.step.process ? this.step.process : 'XX';
      const subProcess = this.step.subProcess ? this.step.subProcess : 'XX';
      const documentType = this.step.documentType ? this.step.documentType : 'XX';
      const creationDate = this.$moment().format('YYYYMMDD');
      return `${this.step.sender}-${process}-${subProcess}-${documentType}-${creationDate}XXXXX`;
    },
    iutLabel() {
      if (this.step.sender === 'SAN') {
        return 'Rut Sanitaria';
      }
      if (this.step.sender === 'PJU') {
        return 'Rut Empresa';
      }
      return 'Rut';
    },
    nameLabel() {
      if (this.step.sender === 'SAN') {
        return 'Nombre empresa sanitaria';
      }
      if (this.step.sender === 'PJU') {
        return 'Razón social *';
      }
      if (this.step.sender === 'OES') {
        return 'Nombre de institución *';
      }
      return '';
    },
  },
  methods: {
    updateNumeration() {
      const { id } = this.$route.params;
      if (id) {
        this.step.numberExp = 0;
      }
    },
    setInputFormat() {
      const mainFormat = this.step.mainFile.format;
      const havePaper = this.step.additionalFiles
        .some((file) => file.format && file.format === 'Papel');
      const haveDigital = this.step.additionalFiles
        .some((file) => file.format && file.format === 'Digital');

      if (!haveDigital && !havePaper) {
        this.step.entryFormatFile = mainFormat.toLowerCase();
      }

      if (mainFormat) {
        if (mainFormat === 'Papel' && havePaper && haveDigital) {
          this.step.entryFormatFile = 'papel_digital';
        }
        if (mainFormat === 'Papel' && havePaper && !haveDigital) {
          this.step.entryFormatFile = 'papel';
        }
        if (mainFormat === 'Papel' && !havePaper && haveDigital) {
          this.step.entryFormatFile = 'papel_digital';
        }
        if (mainFormat === 'Digital' && havePaper && haveDigital) {
          this.step.entryFormatFile = 'papel_digital';
        }
        if (mainFormat === 'Digital' && havePaper && !haveDigital) {
          this.step.entryFormatFile = 'papel_digital';
        }
        if (mainFormat === 'Digital' && !havePaper && haveDigital) {
          this.step.entryFormatFile = 'digital';
        }
      }
      if (!mainFormat) {
        if (havePaper && haveDigital) {
          this.step.entryFormatFile = 'papel_digital';
        }
        if (havePaper && !haveDigital) {
          this.step.entryFormatFile = 'papel';
        }
        if (!havePaper && haveDigital) {
          this.step.entryFormatFile = 'digital';
        }
      }
    },
    getOptionId(id) {
      this.processId = id;
    },
    async addSubject(row) {
      if (row && row.subject && row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });
      if (!isSelected) {
        this.step.subjects = [];
        this.step.subjectsSelected = [];
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    clearSender() {
      this.step.senderCompanyIut = '';
      this.step.senderAddress = '';
      this.step.senderComune = '';
      this.step.senderCompanyName = '';
    },
    setSanitary() {
      const sanitary = this.sanitaryCompaniesState.list
        .find((option) => option.label === this.step.senderCompanyName);
      if (sanitary && sanitary.extra) {
        this.step.senderCompanyIut = sanitary.extra.rut;
        this.step.senderAddress = sanitary.extra.direccion;
        this.step.senderComune = sanitary.extra.comuna;
        this.step.senderCompanyName = sanitary.label;
      }
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.step.additionalFiles.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.step.additionalFiles = this.step.additionalFiles.filter((file) => file.id !== fileId);
    },
    clearCommune() {
      this.step.senderComune = '';
    },
    clearSanitary() {
      this.step.senderCompanyName = '';
      this.step.senderCompanyIut = '';
      this.step.senderAddress = '';
    },
    async isValid() {
      this.error.message = '';
      const isValidForm = await Promise.all([
        this.validateForm('step-1-part-1'),
        this.validateForm('step-1-part-2'),
        this.validateForm('step-1-part-3'),
        this.validateForm('step-1-part-4'),
      ]);

      if (isValidForm.some((part) => !part)) {
        this.error.message = 'Falta que completes toda la información requerida';
        return false;
      }
      if (!this.step.mainFile.name) {
        this.error.message = 'Debes ingresar un documento principal para este expediente';
        return false;
      }
      if (!this.step.subjectsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return false;
      }
      const haveType = this.step.additionalFiles
        .every((file) => file.format);
      if (!haveType) {
        this.error.message = 'Debes colocar el formato de todos los archivos adjuntados';
        return false;
      }

      if (!this.step.mainFile.format) {
        this.error.message = 'Debes colocar el formato del archivo principal';
        return false;
      }
      if (!this.step.declaration) {
        this.error.message = 'Debes declarar que los datos consignados son expresión fiel de la realidad';
        return false;
      }
      return true;
    },
    getSender() {
      let sender = '';
      if (this.step.sender === 'CIU') sender = 'Ciudadano/a';
      if (this.step.sender === 'PJU') sender = 'Persona jurídica';
      if (this.step.sender === 'OES') sender = 'Organismo del estado';
      if (this.step.sender === 'SAN') sender = 'Sanitaria';
      return sender;
    },
    getStepData() {
      const documentTypeName = this.step.documentType
        ? {
          documentTypeName: this.$refs.documentTypes.getOption().label
        }
        : {};
      const processName = this.step.process
        ? {
          processName: this.$refs.process.getOption().label
        }
        : {};
      const subProcessName = this.step.subProcess
        ? {
          subProcessName: this.$refs.subProcess.getOption().label
        }
        : {};
      const documentTypeId = this.step.documentType
        ? {
          documentTypeId: this.$refs.documentTypes.getOption().id
        }
        : {};
      const senderType = this.getSender();
      const officeName = this.step.process
        ? {
          officeName: this.$refs.subjectOffice.getOption().label
        }
        : {};

      return {
        ...this.step,
        senderType,
        ...documentTypeName,
        ...documentTypeId,
        ...processName,
        ...officeName,
        ...subProcessName
      };
    }
  },
  async created() {
    const optionProcess = await this.documentProcessState.list
      .find((option) => option.value === this.step.process) || {};
    this.processId = optionProcess.id || '';
    const { id } = this.$route.params;
    if (!id) {
      this.step.sender = 'CIU';
    }
    this.step.issueDate = Vue.moment().format('YYYY-MM-DD');
    const { data } = await listOptions({
      grupoOpcion: 'oficina-destino-siss',
      deshabilitado: 'no'
    });
    this.sissSubjectOffices = data.opciones.map((option) => ({
      label: option.descripcion,
      id: option.opcionId,
      value: option.opcionId
    }));
  }
};

</script>
<style>
.ti-input {
  border-radius: 5px !important;
}
</style>
